import React from "react";
import { forwardRef } from 'react';
import Header from './Header';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
function H6(props, forwardedRef) {
  return _jsx(Header, {
    ref: forwardedRef,
    ...props,
    size: "h6"
  });
}
export default /*#__PURE__*/forwardRef(H6);